// formDataSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currency: "",
    payment_methods: [],
    checkout: "create",
    dashboard: "create",
    shop: "create",
    import_demo: false,
    name: "",
    email: "",
    apiKey: "",
    store_name: "",
    business_type: "",
    logo: null,
};

const formDataSlice = createSlice({
    name: "formData",
    initialState,
    reducers: {
        setFormData: (state, action) => {
            state = action.payload;
            return state;
        },
        updateFormData: (state, action) => {
            const { key, value } = action.payload;
            return { ...state, [key]: value };
        },
    },
});

export const { setFormData, updateFormData } = formDataSlice.actions;
export default formDataSlice.reducer;
